<template>
    <div class="clickable" @click="open(item)" >
        <div class="home-app d-flex justify-content-center align-items-center" >
            <div v-if="hasIcon">
                <i :class="'icon bi bi-' + item.icon" :key="item.icon" v-if="item.type == 'platform-app' || item.type == 'component'"></i>
                <img :src="item.icon" v-if="item.type == 'forge-app'" class="forge-icon"/>
                <template v-if="item.type == 'integration'">
                    <i :class="'icon bi bi-' + integrationIconValue" v-if="integrationIconType == 'b-icon'"></i>
                    <img :src="integrationIconValue" v-else-if="integrationIconType == 'img'" class="forge-icon"/>
                </template>
            </div>
            <h3 v-else>{{ text }}</h3>
            
            <div 
                v-if="item.type == 'forge-app' && $can('manage forge')" 
                :class="item.status === 'failed' ? 'status-badge' : 'settings-icon'"
                @click.stop="goToSettings"
                v-b-tooltip.hover
                :title="item.status === 'failed' ? (item.status_message || 'Installation failed') : 'Settings'"
            >
                <b-icon v-if="item.status === 'failed'" icon="exclamation-triangle-fill"></b-icon>
                <b-icon v-else icon="gear-fill"></b-icon>
            </div>
        </div>

        <div class="name">{{ title }}</div>
    </div>
</template>

<script>
import { truncate } from 'lodash'

export default {
    props: {
        item: {
            type: Object
        }
    },

    computed: {
        text() {
            const t = this.$translateLabel(this.item.label, this.item.name)

            if (!t || t.length === 0) {
                return this.item.name ? this.item.name[0].toUpperCase() : '?'
            }

            return t[0].toUpperCase()
        },

        hasIcon() {
            if (!this.item.icon) return false
            
            // For integrations, check if icon has proper format and value after colon
            if (this.item.type === 'integration') {
                if (!this.item.icon.includes(':')) return false
                const value = this.item.icon.split(':')[1]
                return value && value.trim().length > 0
            }
            
            return true
        },

        integrationIconType() {
            if (!this.item.icon || this.item.type !== 'integration') return null
            const part = this.item.icon.split(':')
            return part[0]
        },

        integrationIconValue() {
            if (!this.item.icon || this.item.type !== 'integration') return ''
            return this.item.icon.replace(`${this.integrationIconType}:`, '')
        },

        title() {
            const t = this.$translateLabel(this.item.label, this.item.name)

            if (t.includes("_")) {
                return truncate(t, {
                    length: 12,
                    ommit: '...'
                })
            }

            return t
        }
    },

    methods: {
        open(item) {
            this.$emit('open', item)
        },
        
        goToSettings() {
            this.$emit('settings-click', this.item)
        }
    }
}
</script>

<style scoped lang="scss">
.clickable {
  text-align: center;
  cursor: pointer;
  transition: transform 0.2s ease;

  &:hover {
    transform: translateY(-4px);
  }
}

.home-app {
  background-color: var(--border-default);
  width: 64px;
  height: 64px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
  border-radius: 15px;
  margin: 0 auto;
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 8px 16px rgba(102, 126, 234, 0.3);
    background: linear-gradient(135deg, var(--primary-start), var(--primary-end));
  }

  & > h3 {
    line-height: 64px;
  }

  & .icon {
    font-size: 40px;
    margin-top: 11px;
  }

  &:has(.forge-icon) {
    background-color: transparent;
    box-shadow: none;
  }
}

.name {
    text-align: center;
    font-size: 12px;
    width: 64px;
    margin: 5px auto;
}

.forge-icon {
    border-radius: 8px;
    width: 100%;
    height: 100%;
    object-fit: fill; /* or 'fill' if you want to stretch */
}

.settings-icon {
    position: absolute;
    top: 4px;
    right: 4px;
    width: 20px;
    height: 20px;
    background: rgba(102, 126, 234, 0.9);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: opacity 0.2s ease;
    z-index: 10;
    
    svg {
        font-size: 11px;
        color: white;
    }
    
    &:hover {
        background: rgba(102, 126, 234, 1);
        transform: scale(1.1);
    }
}

.home-app {
    position: relative;
    
    &:hover .settings-icon {
        opacity: 1;
    }
}

.status-badge {
    position: absolute;
    top: -4px;
    right: -4px;
    width: 22px;
    height: 22px;
    background: #dc3545;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px solid white;
    z-index: 10;
    
    svg {
        font-size: 12px;
        color: white;
    }
}
</style>